// A tiny concurrency limiter for map layer fetches. Caps how many requests are
// in flight at once so enabling many proxied layers can't stampede the server's
// request-thread pool; the rest queue and run as slots free up.
export function createFetchQueue (maxConcurrent = 4) {
  const pending = []
  let active = 0

  const runNext = () => {
    pending.shift()?.()
  }

  return async function enqueue (task) {
    if (active >= maxConcurrent) {
      await new Promise((resolve) => pending.push(resolve))
    }
    active += 1
    try {
      return await task()
    } finally {
      active -= 1
      runNext()
    }
  }
}
